angular
  .module("myApp")

  .controller("SettingsTextsController", function ($scope, $http, Dialog, TextSave) {
    $scope.editing = false

    $scope.teksti = []

    this.refresh = () => {
      $scope.teksti = []

      $http({ method: "GET", url: "/data/cms_texts" }).then((ts) => {
        ts.data.forEach((t) => {
          const snip = t.teksts.replace(/(<[^>]+>| )+/g, " ")
          $scope.teksti.push({
            kods: t.kods,
            teksts: t.teksts,
            snip: snip.length > 150 ? `${snip.substring(0, 150)}...` : snip,
          })
        })
      })
    }

    this.edit = (item, $ev) => {
      $ev?.preventDefault()
      $ev?.stopPropagation()
      $scope.editing = item
      Dialog.dialog("pages/dialogs/settings.text.form.html", item, {}, (p, action) => {
        if (action === "save") {
          return Dialog.finish(new TextSave(p), this.refresh)
        }
      })
    }

    this.refresh()
  })

  .controller(
    "SettingsSubmissionController",
    function ($scope, uuiData, Dialog, PieteikumuKartaEdit, PieteikumuKartaRemove) {
      $scope.kartas = uuiData.list("pieteikumu_karta_list")

      $scope.decode_restriction = {
        none: "visi",
        saimniecisks: "saimnieciskie",
        nesaimniecisks: "ne-saimnieciskie",
        fundamentals: "fundamentālie",
        rupniecisks: "rūpnieciskie",
      }
      $scope.decode_flow = {
        default: "Pilnā plūsma",
        compact: "Pakāpeniskā plūsma",
      }

      this.editKarta1112 = (p, $ev) => {
        $ev?.stopPropagation()
        Dialog.dialog("pages/dialogs/settings.karta.1112.form.html", p, {}, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PieteikumuKartaRemove({
                id: p.id,
              }),
              this.refresh
            )
          } else if (action === "save") {
            return Dialog.finish(new PieteikumuKartaEdit(p), this.refresh)
          }
        })
      }

      this.editKarta1119 = (p, $ev) => {
        $ev?.stopPropagation()
        const np = {
          ...p,
          iesniegumi_open: moment(p.iesniegumi_open).toDate(),
          iesniegumi_close: moment(p.iesniegumi_close).toDate(),
        }
        Dialog.dialog("pages/dialogs/settings.karta.1119.form.html", np, {}, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PieteikumuKartaRemove({
                id: p.id,
              }),
              this.refresh
            )
          } else if (action === "save") {
            return Dialog.finish(new PieteikumuKartaEdit(p), this.refresh)
          }
        })
      }

      this.refresh = () => {
        $scope.kartas = uuiData.list("pieteikumu_karta_list")
      }

      this.newKarta = (r, $ev) => {
        this.editKarta1119(
          {
            new: true,
            konkurss: "1.1.1.9",
            ir_aktuala: false,
            drikst_iesniegt: false,
            drikst_precizet: false,
            ir_sadala_162: false,
            ir_sadala_25: false,
            sakuma_gads: +moment().format("YYYY"),
            vesture: [],
            sekvence: 1,
            sablons: `1.1.1.9/LZP/1/${moment().format("YY")}/NNN`,
            restrict_veids: "none",
            restrict_kategorija: "none",
            plusma: "default",
          },
          $ev
        )
      }
    }
  )

  .controller("SettingsEmailController", function ($scope, $state, Notification, uuiData, ChangeSetting) {
    $scope.settings = {}

    this.loadSettings = () => {
      uuiData.list(
        "settings_list",
        (s) => {
          _.each(s, (se) => {
            $scope.settings[se.name] = se.value
          })
        },
        $scope.failing
      )
    }

    this.setMpNotifications = (s) => {
      const v = new ChangeSetting({
        name: "email.mp-notifications.enabled",
        value: s ? "true" : "false",
      })
      v.$create(this.loadSettings, $scope.failing)
    }

    this.loadSettings()
  })

  .controller(
    "SettingsNzdisController",
    function ($scope, $state, Notification, uuiData, ChangeSetting, ExportNzdis, SetNzdisExportSettings) {
      $scope.settings = {}
      $scope.log = []

      this.refresh = () => {
        this.loadSettings()
        this.loadLog()
      }

      this.loadLog = () => {
        uuiData.list(
          "export_log?limit=5",
          (l) => {
            $scope.log = l
          },
          $scope.failing
        )
      }

      this.loadSettings = () => {
        uuiData.list(
          "settings_list",
          (s) => {
            _.each(s, (se) => {
              $scope.settings[se.name] = se.value
            })
          },
          $scope.failing
        )
      }

      this.setNzdisExport = (s) => {
        const v = new ChangeSetting({
          name: "export.nzdis.enabled",
          value: s ? "true" : "false",
        })
        v.$create(this.loadSettings, $scope.failing)
      }

      this.toggleNzdisSign = () => {
        if ($scope.settings["export.nzdis.signed"] === "true") {
          $scope.settings["export.nzdis.signed"] = "false"
        } else {
          $scope.settings["export.nzdis.signed"] = "true"
        }
      }

      this.nzdis_export_running = false

      this.manualNzdisExport = () => {
        // if (!confirm("Veikt manuālu datu eksportu uz NZDIS?")) return
        this.nzdis_export_running = true
        const v = new ExportNzdis()
        v.$create(
          () => {
            this.nzdis_export_running = false
            Notification.success("Eksporta process palaists")
            this.loadLog()
          },
          (e) => {
            this.nzdis_export_running = false
            $scope.failing(e)
            // eslint-disable-next-line no-console
            console.log({ e })
          }
        )
      }

      this.saveNzdisAdvanced = () => {
        const v = new SetNzdisExportSettings({
          export_nzdis_signed: $scope.settings["export.nzdis.signed"],
          export_nzdis_key_public: $scope.settings["export.nzdis.key.public"],
          export_nzdis_key_private: $scope.settings["export.nzdis.key.private"],
          export_nzdis_url: $scope.settings["export.nzdis.url"],
        })
        v.$create(() => {
          Notification.success("Iestatījumi saglabāti.")
          this.loadSettings()
        }, $scope.failing)
      }

      this.refresh()

      return this
    }
  )
